import React from 'react';
import { Typography, theme } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface ProcessBlockedBannerProps {
  message: string;
  style?: React.CSSProperties;
}

/** Shown where a process cannot be started because the administrator blocked it. */
export const ProcessBlockedBanner = ({
  message,
  style,
}: ProcessBlockedBannerProps): React.ReactElement => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        padding: '14px 18px',
        borderRadius: token.borderRadiusLG,
        background: token.colorWarningBg,
        border: `1px solid ${token.colorWarningBorder}`,
        borderLeft: `4px solid ${token.colorWarning}`,
        ...style,
      }}
    >
      <div
        style={{
          flex: '0 0 auto',
          width: 40,
          height: 40,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: token.colorWarningBorder,
          color: token.colorWarningActive,
          fontSize: 18,
        }}
      >
        <LockOutlined />
      </div>
      <div style={{ minWidth: 0 }}>
        <Typography.Text strong style={{ display: 'block', fontSize: 15 }}>
          {t('processStartSettings.blockedTitle')}
        </Typography.Text>
        <Typography.Text type="secondary">{message}</Typography.Text>
      </div>
    </div>
  );
};
